import { BaseLookupModel, PaginationFilterRequest } from "./core.model";
import { UserLookup } from "./user.model";

export enum ClubMemberRoleEnum {
  Owner = 1,
  Captain = 2,
  // 3 is permanently retired. It meant EventOrganizer under the old enum and
  // must never be reused, so an un-updated mobile client cannot misread a value.
  Member = 4,
}

/** 3 is omitted deliberately. A stale row holding it renders as its raw value
 *  rather than being silently mislabelled as something it is not. */
export const ClubMemberRoleList = [
  { value: 1, label: "Owner" },
  { value: 2, label: "Captain" },
  { value: 4, label: "Member" },
];

/** Owner is absent: ownership is assigned only through the Assign Owner action,
 *  which also fixes the club's JoinType in the same transaction. */
export const ClubMemberRoleAssignableList = [
  { value: 2, label: "Captain" },
  { value: 4, label: "Member" },
];

export enum ClubMembershipStatusEnum {
  Pending = 1,
  Active = 2,
  Rejected = 3,
  Left = 4,
  Removed = 5,
  Banned = 6,
}

export const ClubMembershipStatusList = [
  { value: 1, label: "Pending" },
  { value: 2, label: "Active" },
  { value: 3, label: "Rejected" },
  { value: 4, label: "Left" },
  { value: 5, label: "Removed" },
  { value: 6, label: "Banned" },
];

export interface RunningClubMember {
  id: number;
  runningClubId: number;
  userId: number;
  role: ClubMemberRoleEnum;
  status: ClubMembershipStatusEnum;
  joinedAt?: string;
  runningClub: BaseLookupModel;
  user: UserLookup;
}

export interface UpsertRunningClubMember {
  id?: number;
  runningClubId?: number;
  userId?: number;
  // Both are REQUIRED by the API ([EnumDataType]); never send undefined.
  role: ClubMemberRoleEnum;
  status: ClubMembershipStatusEnum;
}

export class RunningClubMemberPaginationFilterRequest extends PaginationFilterRequest {
  runningClubId?: number;
  userId?: number;
  role?: ClubMemberRoleEnum;
  status?: ClubMembershipStatusEnum;
}
